/**
 * The 1943 map: U.S. Army Map Service 1:25,000 sheets of Sicily.
 *
 * Owner, 2026-09-25: first five sheets of the landing coast he downloaded from
 * the Perry-Castañeda Library (UT Austin), then *"kan du ladda hem alla kartor
 * i serien?"* — 143 sheets, the south, centre and east of the island. The
 * library has nothing for Palermo, Trapani, most of the north coast or
 * Messina (its index map, read the same day).
 *
 * `tools/ams-georef.py` places each sheet from its number and measures it
 * against the IGM 1:25,000 near every corner; `tools/ams-tiles.py` cuts the
 * tiles; `deploy.sh` ships them beside the two environments; the server reads
 * them at `/api/ams/…` and answers 204 where no sheet reaches.
 *
 * Five sheets rode in the web build as static files for the first hour
 * (0.1.160–0.1.161), one source per sheet so the map never asked for a tile
 * that did not exist. One source now: a 204 is an empty tile to the map.
 */
/**
 * The three series, coarsest first — the order they are stacked. Owner,
 * 2026-09-25: *"Undvik IGM och använda enbart AMS så långt det räcker."*
 * `cut` is the zoom range the tiles exist at (histmap.rs `AMS_SERIES`);
 * `from` is where a layer starts to show. The 1:50,000 placed 80 of its 86
 * sheets and so carries the overview as well as the middle; the 1:100,000
 * lies under it for the few places it has no sheet (Marsala, the Egadi);
 * close in the 1:25,000 lies over both. Each finer series is drawn over the
 * coarser, which shows through wherever the finer has no sheet.
 */
export const AMS_LAYERS = [
  { series: "100k", cut: [8, 14], from: 8 },
  { series: "50k", cut: [8, 15], from: 8 },
  { series: "25k", cut: [11, 16], from: 14 },
] as const;
/** Where the old maps begin to show. */
export const AMS_MIN_ZOOM = 8;
export const AMS_ATTRIBUTION =
  "AMS Italy 1:100,000, 1:50,000 and 1:25,000, 1941–43 · Courtesy of the University of Texas Libraries, The University of Texas at Austin";
/** What the sheets cover, [west, south, east, north] — requests stop here. */
export const AMS_BOUNDS: [number, number, number, number] = [12.44, 36.64, 15.47, 38.0];
export const amsTiles = (series: string) => `/api/ams/${series}/{z}/{x}/{y}`;
